import { create } from "zustand";
import axiosInstance from "../api/axiosInstance";
import { useUserStore } from "./useUserStore";
import useAuthStore from "./useAuthStore";


interface QuestionOption {
    id: number;
    question_id: number;
    option: string;
  }
interface Question {
  id: number;
  question: string;
  sub_title: string;
  questions_options: QuestionOption[];
}

interface RegisterQuestionsState {
  questions: Question[];
  loading: boolean;
  error: string | null;
  getRegisterQuestions: () => Promise<void>;
  getQuestionByTitle: (title: string) => Question | null;
  getUserAnswerByTitle: (title: string) => Promise<number | null>;
}

export const useRegisterQuestionsStore = create<RegisterQuestionsState>((set, get) => ({
  questions: [],
  loading: false,
  error: null,

  getRegisterQuestions: async () => {
    set({ loading: true, error: null });

    try {
      const response = await axiosInstance.get("/getRegisterQuestions");

      if (response.status === 200) {
        set({ questions: response.data.rows, loading: false });
      }
    } catch (error) {
      console.error("Error fetching registration questions:", error);
      set({ error: "Failed to fetch questions", loading: false });
    }
  },

  getQuestionByTitle: (title: string) => {
    const { questions } = get();
  
    
    return questions.find((q) => q.sub_title.toLowerCase() == title.toLowerCase()) || null;
  },

getUserAnswerByTitle: async (title: string) => {
  // Await the question loading
  await useRegisterQuestionsStore.getState().getRegisterQuestions();
  const authStore = useAuthStore.getState();
  const userId = authStore.user?.id;
  await  useUserStore.getState().getUserDetails(userId);

  console.log('question?.id.....................');
  

  const questions = useRegisterQuestionsStore.getState().questions;
  const user = useUserStore.getState().user;

  const question = questions.find(
    (q: any) => q.sub_title.toLowerCase() === title.toLowerCase()
  );

  if (!question) return null;
console.log('question?.id.....................',user);
  const answerEntry = user.user_answers.find(
    (a: any) => Number(a.question_id) === Number(question.id)
  );

  console.log('answerEntry', answerEntry);

  return answerEntry?.answer_id ?? null;
}
}));
